module.exports = __webpack_public_path__ + "assets/ic_badge_09.9b32646e.svg";